import { render, staticRenderFns } from "./drawAllParts.vue?vue&type=template&id=056e4a4f&scoped=true&"
import script from "./drawAllParts.vue?vue&type=script&lang=js&"
export * from "./drawAllParts.vue?vue&type=script&lang=js&"
import style0 from "./drawAllParts.vue?vue&type=style&index=0&id=056e4a4f&prod&scoped=true&lang=less&"
import style1 from "./drawAllParts.vue?vue&type=style&index=1&id=056e4a4f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e4a4f",
  null
  
)

export default component.exports